import _ from "lodash"
  export const updateOrder = (state, action) => {
    let list = state.list;
    const id = action.payload[0].uuid;
  
    const index = _.findIndex(list, ["uuid", id]);
    list[index] = action.payload[0];
    return list;
  };